import styled from 'styled-components'
import Box, {BoxProps} from './Box'

export interface ContainerProps extends BoxProps {
  maxWidth?: string
}

const Container = styled(Box).attrs<ContainerProps>(
  ({theme, maxWidth, $styles = {}, ...restProps}) => ({
    $mx: 'auto',
    $px: [20, null, null, null],
    $styles: {
      maxWidth: maxWidth || theme.layout.defaultContainerWidth,
      ...$styles,
    },
    ...restProps,
  }),
)({})

export default Container
